/**
 * Created with IntelliJ IDEA.
 * User: denis
 * Date: 11/18/13
 * Time: 4:56 PM
 * To change this template use File | Settings | File Templates.
 */
Ext.ns('mx.app.widget');

mx.app.widget.HuePicker = Ext.extend(mx.comp.FieldGroup, {
    sliderOptions: {
        vertical: false,
        minValue: 1,
        maxValue: 360,
        keyIncrement: 1,
        increment: 1,
        clickToChange: true,
        animate: true,
        dragging: false,
    },
    saturation: 100,
    lightness: 50,
    initComponent: function() {
        this.slider = new Ext.Slider(this.sliderOptions);
        this.slider.value = this.value;
        this.items = [this.slider];
        mx.app.widget.HuePicker.superclass.initComponent.call(this);
    },
    afterRender: function() {
        mx.app.widget.HuePicker.superclass.afterRender.call(this);
        this.slider.thumb.dom.style.borderRadius = '16px';
        this.slider.thumb.dom.style.width = '17px';
        this.slider.thumb.dom.style.height = '17px';
        this.slider.thumb.dom.style.boxShadow = '0 0 2px 0px #555';
        this.slider.on('change', this.updateColorPreview, this);
        this.updateColorPreview();
    },
    updateColorPreview: function() {
        this.slider.thumb.dom.style.background =
            'hsl(' + [this.slider.value, this.saturation + '%', this.lightness + '%'].join(',') + ')';
    },
    getValue: function() {
        return this.slider.getValue();
    },
});
